export default __webpack_public_path__ + "static/media/thumb_sf2.539a74a0.png";